import React, { useContext } from "react";
import { useDispatch, useSelector } from 'react-redux';
import { EPaymentModes, IKioskModel, IkioskManager } from "../../../../models/kioskModel";
import { SuperParentContext } from "../../Container/kioskcontext";
import PageLoading from "./PageLoading";

const ThemeOneKioskManager: React.FC = () => {
    const loadings: boolean = useSelector((state: any) => (state?.kioskReducer as IKioskModel)?.loading) || false;
    const dispatch = useDispatch();
    const Context = useContext(SuperParentContext);
    const selectionArea = useSelector((state: any) => {
        if (state?.kioskReducer?.selectedArea)
            return (state.kioskReducer as IKioskModel).selectedArea;
        else return IkioskManager.HOME;
    });
    console.log("selectionArea::", selectionArea);
    const getSelectedAreaComponent = (value) => {
        console.log('getSelectedAreaComponent=>', value);
        switch (value) {
            case IkioskManager.MRNVERIFICATION:
                return <Context.MrnVerfication />;
            case IkioskManager.EMIRADESVERIFICATION:
                return <Context.EmiratesIdVerification />;
            case IkioskManager.TOKENAREA:
                return <Context.ThemeOneTokenGeneration />;
            case IkioskManager.APPOINTMENTSAREA:
                return <Context.ThemeOneAppointmentsList />;
            case IkioskManager.PATIENTJOUNEYEXPLORE:
                return <Context.PatientJouneyExplore />;
            case IkioskManager.EXISTPATIENTJOUNEYPAGE:
                return <Context.PatientJouneyExistPage />;
            case IkioskManager.LOADAPPOINTMENTS:
                return <Context.PageLoading />;
            default:
                return <Context.ThemeOneHome />;
        }
    }
    return (
        <>
            {getSelectedAreaComponent(selectionArea)}
            <Context.ThemeOneErrorBlock />
        </>
    )

}
export default React.memo(ThemeOneKioskManager);